/* eslint-disable no-undef */
import { localWebserverWebCache } from "@/api/orderkiosk";
import { generate_reference, generate_random_string } from "@/utils/helpers";
import { getConfig } from "@/utils/config";

let ENDPOINT = getConfig().VUE_APP_PAYMENT_ENDPOINT;

let DEVMODE = false;
let NOTERMINAL = false;
let TRANSMISSION_STATUS_TIMEOUT = 5000;

let ws;
let terminals = [];

const CloseCodes = {
  4001: "INVALID_DATA_TYPE",
  4002: "INVALID_PAYLOAD_TYPE",
  4003: "AUTHENTICATION_ERROR"
};

function auth() {
  if (NOTERMINAL) {
    return;
  }
  terminals.forEach(terminal => {
    console.log("Authenticating as " + terminal.terminal_identifier);
    ws.send(
      JSON.stringify({
        method: "auth",
        terminal: terminal.terminal_identifier,
        token: terminal.terminal_authentication_token
      })
    );
  });
}

let floating_payments = {};
let floating_coupon_request = [];
let floating_transmission_status = [];
const DUMMY_PAYMENT_DATA = {
  status: "final",
  cardinfo: {
    cardtoken:
      "ad276e1b8af114aa300318b90094108b2ec2f37f9dc390086e994e57ee19c04c",
    cardtype: "0b100000",
    "Formatted card number": "xxxxxxxxxxxxxxx4001"
  },
  receipt: {
    "PIN status text": "PIN OK",
    "Transaction currency code": 978,
    "Period number": 1,
    "Authorization code": "158963",
    TerminalIdentifier: "50281098",
    "Transaction identifier": 3,
    "Transaction service identifier": "8810",
    "Transaction amount (default)": 1,
    "Application identifier": "a0000000032020",
    "Card brand label name":
      "V PAY\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000",
    "Primary account number": "xxxxxxxxxxxxxxx4001",
    "Expiration Date": "211231",
    "Merchant reference": "txAHdnBQD2dG2WM",
    "Ticket footer line 1": "DANKE",
    "Ticket footer line 2": "AUF WIEDERSEHEN",
    "Merchant user identifier":
      "38119035\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000",
    "PAN sequence number": "\\u0001",
    "Shop logo": " ",
    "Terminal identifier": "044958EQ",
    "Shop Location": " ",
    "Card Read Method": "Contact",
    "Signature label text": "Leseweise: CHIP",
    "Date and time": 20200331144022
  },
  reference: "testing integration",
  cardbrandidentifier: 1003,
  ticket: [
    [0, ""],
    [0, "POI: 50281098"],
    [0, "KUNDENBELEG"],
    [0, "------------------------------------------------"],
    [0, "Terminal:  044958EQ    Haendler:        38119035"],
    [0, "Zeitraum:      0001    Transaktion:     00000003"],
    [0, ""],
    [1, "         V PAY          "],
    [0, ""],
    [0, "                (A0000000032020)                "],
    [0, ""],
    [0, "Karte: xxxxxxxxxxxxxxx4001 "],
    [0, ""],
    [0, "Kartenseriennummer: 1"],
    [0, "Gultig bis: 31/12/21"],
    [0, ""],
    [0, "ZAHLUNG                 "],
    [0, "Datum: 31/03/2020 14:40                          "],
    [0, ""],
    [0, "Autorisierungscode: 158963  "],
    [0, ""],
    [0, "REF: txAHdnBQD2dG2WM"],
    [0, ""],
    [0, "Gesamtbetrag:         0,01 EUR"],
    [0, ""],
    [0, "Contact"],
    [0, ""],
    [0, "Leseweise: CHIP"],
    [0, "PIN OK"],
    [0, ""],
    [1, "         DANKE          "],
    [1, "    AUF WIEDERSEHEN     "]
  ],
  approved: 1,
  approvalID: "158963",
  terminal: "50281098",
  cardbrandlabelname: "V PAY",
  error: 0,
  callbackID: 861525,
  errormsg: "",
  "card processing data": {
    "Processing application ID": 35,
    "Merchant user identifier":
      "38119035\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000\\u0000",
    "Record identifier": 1,
    terminalident: "044958EQ",
    "Acquirer identifier": 99900005,
    "Application identifier": "a0000000032020",
    "Card brand label name": "V PAY",
    "Discretionary data": {
      "Card brand label name": "V PAY",
      "Formatted card number": "482242xxxxxxxxx4001"
    },
    "Issuer identification number": 482242,
    "Card brand identifier": 1003
  },
  txid: "txAHdnBQD2dG2WM",
  ssai: 345185,
  amount: 1,
  cvm: 4718592,
  time: 1585658424.391335,
  cancelled: 0,
  incidentcode: "0"
};

export function resetPaymentTimout(txid, terminal) {
  console.log("resetPaymentTimout txid: " + txid);
  ws.send(JSON.stringify({ method: "reset_payment_timeout", txid, terminal }));
}

export function cancel(txid, terminal) {
  console.log("cancel txid: " + txid);
  console.log("cancel terminal: " + terminal);
  let code = "cancel";
  ws.send(JSON.stringify({ method: "cancel", txid, terminal, code }));
}

export function debit_meta(txid, meta_data) {
  console.log("debit_meta");
  let p = new Promise(function(resolve, reject) {
    ws.send(JSON.stringify({ method: "debit_meta", txid, meta_data }));
  });
  return p;
}

export function debit(
  currency_code,
  order,
  terminal,
  lineItems,
  vatDetails,
  coupons
) {
  let amount = vatDetails.absoluteTotal.multiply(100).value;

  if (
    (NOTERMINAL && DEVMODE) ||
    process.env.VUE_APP_DEV_AUTO_ACCEPT_DUMMY_PAYMENT === "1"
  ) {
    console.warn("!---> Auto accepting dummy payment.");
    return new Promise(function(resolve, reject) {
      setTimeout(() => {
        resolve(DUMMY_PAYMENT_DATA);
      }, 3000);
    });
  }
  if (NOTERMINAL) {
    return Promise.reject(new Error("No Terminal Connected"));
  }
  if (DEVMODE) {
    amount = 1;
  }
  let reference = generate_reference();
  return new Promise(function(resolve, reject) {
    floating_payments[reference] = [resolve, reject];
    ws.send(
      JSON.stringify({
        method: "debit",
        amount,
        currency_code,
        reference,
        order,
        terminal,
        lineItems,
        vatDetails,
        coupons
      })
    );
  });
}

export function transmission_status(reference) {
  return new Promise(function(resolve, reject) {
    let reject_timer = setTimeout(
      reject,
      TRANSMISSION_STATUS_TIMEOUT,
      new Error("Transmission timeout error")
    );
    floating_transmission_status = [resolve, reject, reject_timer, reference];
  });
}

export function coupon(barcode) {
  return new Promise(function(resolve, reject) {
    if (
      process.env.NODE_ENV === "development" &&
      process.env.VUE_APP_DANGEROUSLY_SKIP_COUPON_VERIFICATION === "1"
    ) {
      console.warn("ACHTUNG! Skipping coupon verification!");
      return resolve(generate_random_string(16));
    }

    floating_coupon_request = [resolve, reject];
    ws.send(JSON.stringify({ method: "coupon", coupon: barcode }));
  });
}

function determinePaymentCredentials() {
  terminals = [];
  if (process.env.NODE_ENV === "development") {
    terminals.push({
      terminal_identifier: "P400Plus-803569064",
      terminal_authentication_token: "MtYnxVIpGbWepT0"
    });
    terminals.push({
      terminal_identifier: "cikam-1336",
      terminal_authentication_token: "cikam"
    });
    DEVMODE = true;
    NOTERMINAL = false;
  }

  if (getConfig().VUE_APP_ADD_DEV_TERMINAL === "1") {
    terminals.push({
      terminal_identifier: "dev",
      terminal_authentication_token: "dev"
    });
    DEVMODE = false;
    NOTERMINAL = false;
    return;
  }

  if (typeof window.mmsKiosk !== "undefined") {
    if (
      typeof window.mmsKiosk.jsonConfig !== "undefined" &&
      typeof window.mmsKiosk.jsonConfig.getConfigValue !== "undefined"
    ) {
      let terminal_settings = window.mmsKiosk.jsonConfig.getConfigValue(
        "js_terminal"
      );
      if (typeof terminal_settings === "object") {
        if (terminal_settings.hasOwnProperty("extra_terminals")) {
          terminal_settings.extra_terminals.forEach(extra_terminal => {
            terminals.push({
              terminal_identifier: extra_terminal.poi,
              terminal_authentication_token: extra_terminal.authtoken
            });
          });
        }
        if (
          terminal_settings.hasOwnProperty("poi") &&
          terminal_settings.hasOwnProperty("authtoken") &&
          terminal_settings.hasOwnProperty("mode")
        ) {
          if (
            terminal_settings.mode === "normal" ||
            terminal_settings.mode === "minimal"
          ) {
            terminals.push({
              terminal_identifier: terminal_settings.poi,
              terminal_authentication_token: terminal_settings.authtoken
            });
            DEVMODE = terminal_settings.mode === "minimal";
          } else if (
            terminal_settings.mode === "none" ||
            terminal_settings.mode === "devel"
          ) {
            terminals.push({
              terminal_identifier: "",
              terminal_authentication_token: ""
            });
            DEVMODE = terminal_settings.mode === "devel";
            NOTERMINAL = true;
          }
        }
      }
    }
  } else if (!DEVMODE) {
    //We dont have a Terminal:
    NOTERMINAL = true;
  }
}

class Connector {
  constructor(store) {
    this.store = store;
  }

  connect() {
    determinePaymentCredentials();
    if (NOTERMINAL) {
      return;
    }
    ws = new WebSocket(ENDPOINT);
    ws.onopen = () => {
      console.log("websocket opened");
      auth();
    };

    ws.onmessage = event => {
      console.log("websocket received: " + event.data);
      let res = JSON.parse(event.data);
      if (res.method === "debit_cikam_callback") {
        console.log("debit_cikam_callback");
        // TODO not dry error handling
        if (!(res.response.reference in floating_payments)) {
          console.log(
            "Received callback or reply for unknown payment, ignoring."
          );
          return;
        }
        let ref = res.response.reference;
        let floating = floating_payments[ref];
        if (res.response.error !== 0) {
          console.log("rejecting");
          let paymentError = new Error(res.response.errormessage);
          if (res.response.error_code) {
            paymentError.code = res.response.error_code;
          }
          floating[1](paymentError);
          delete floating_payments[ref];
          return;
        }
        if (res.response.details) {
          this.store.dispatch("SET_CIKAM_RESPONSE", res.response);
        }
      } else if (res.method === "auth_reply") {
        if (res.successful) {
          console.log("Auth Successful");
          this.store.dispatch("ADD_TERMINAL", {
            terminal: res.terminal,
            terminal_type: res.terminal_type
          });
        } else {
          console.log("Auth Unsuccessful");
        }
      } else if (
        res.method === "debit_reply" ||
        res.method === "debit_callback"
      ) {
        let txid = res.txid ? res.txid : res.response.txid;
        if (txid) {
          this.store.dispatch("SET_TXID", txid);
        }
        let ref = res.reference ? res.reference : res.response.reference;
        if (!(ref in floating_payments)) {
          console.log(
            "Received callback or reply for unknown payment, ignoring."
          );
          return;
        }
        let floating = floating_payments[ref];
        //TODO: Add more data about failure e.g. which coupon tickets failed validation.
        if (res.response.error !== 0) {
          console.log("rejecting");
          let paymentError = new Error(res.response.errormsg);
          if (res.response.error_code) {
            paymentError.code = res.response.error_code;
          }
          floating[1](paymentError);
          delete floating_payments[ref];
          return;
        }
        if (res.response.status === "final") {
          if (res.response.approved === 1) {
            console.log("resolving");
            floating[0](res.response);
          } else {
            floating[1](new Error("Payment not approved"));
            console.log("rejecting");
          }
          delete floating_payments[ref];
          return;
        }
        if (res.response.status === "cancel") {
          console.log("rejecting");
          let paymentError = new Error("Payment canceled.");
          if (res.response.error_code) {
            paymentError.code = res.response.error_code;
          }
          floating[1](paymentError);
          delete floating_payments[ref];
          return;
        }
      } else if (res.method === "coupon_reply") {
        if (floating_coupon_request.length > 0) {
          if (res.successful) {
            floating_coupon_request[0](res.ticket);
          } else {
            floating_coupon_request[1](new Error(res.response));
          }
          floating_coupon_request = [];
          return;
        }
      } else if (res.method === "local_network_request") {
        let manager = new LocalNetworkRequestManager(res);
        manager.post();
        return;
      } else if (res.method === "debit_transmitted") {
        if (floating_transmission_status.length > 0) {
          if (floating_transmission_status[3] != res.reference) {
            console.log(
              "Invalid debit_transmitted response = " + JSON.stringify(res)
            );
            return;
          }
          if (res.response) {
            console.log(
              "debit_transmitted response = " + JSON.stringify(res.response)
            );
            floating_transmission_status[0](res.response);
            clearTimeout(floating_transmission_status[2]);
          } else {
            floating_transmission_status[1](new Error("Transmission failed"));
            floating_transmission_status = [];
          }
        }
      } else if (res.method === "meta_data_updated") {
        console.log("meta_data_updated res = " + JSON.stringify(res));
      } else {
        console.log("Error, invalid method res = " + JSON.stringify(res));
      }
    };

    ws.onclose = event => {
      let reason = CloseCodes[event.code];
      console.log("websocket closed (" + (reason ? reason : event.code) + ")");
      setTimeout(() => {
        this.connect();
      }, 1000);
    };

    ws.onerror = error => {
      console.log("websocket error: " + error.message);
      ws.close();
    };
  }
}

class LocalNetworkRequestManager {
  static WEBCACHE_REQ_TIMEOUT = 5000;
  static ERR_CODE_ECONNABORTED = "ECONNABORTED";
  static ERR_CODE_ECONNREFUSED = "ECONNREFUSED";

  constructor(res) {
    this.response = res && res.response ? res.response : {};
    this.reference = this.response.reference ? this.response.reference : null;
  }

  reject() {
    if (this.reference) {
      console.log("reject - this.reference: " + this.reference);
      let floating = floating_payments[this.reference];
      if (floating) {
        let paymentError = new Error("No connection.");
        paymentError.code = "no_connection";
        floating[1](paymentError);
        delete floating_payments[this.reference];
      } else {
        console.log("reject - failed, floating missing.");
      }
    } else {
      console.log("reject - failed, reference missing.");
    }
  }

  handleError(code) {
    console.log("handleError - code: " + code);
    this.reject();
  }

  post() {
    if (!this.response.payload) {
      console.log("payload is mandatory.");
      return;
    }
    let reqConfig = {
      method: "POST",
      data: this.response.payload,
      timeout: LocalNetworkRequestManager.WEBCACHE_REQ_TIMEOUT
    };

    localWebserverWebCache()
      .request(reqConfig)
      .then(webCacheResponse => {
        let id = this.response.id;
        let terminal = this.response.terminal;
        let txid = this.response.txid;
        let webCacheResponseData = webCacheResponse["data"];
        console.log(
          "webCache/rq data: " + JSON.stringify(webCacheResponseData)
        );
        ws.send(
          JSON.stringify({
            method: "local_network_request_response",
            id,
            terminal,
            txid,
            webCacheResponseData
          })
        );
      })
      .catch(error => {
        console.log("webCache/rq failed. " + error);
        if (error.response) {
          this.handleError(error.response.status);
        } else if (error.code) {
          let status;
          if (error.code === LocalNetworkRequestManager.ERR_CODE_ECONNABORTED) {
            console.log("ERR_CODE_ECONNABORTED");
            status = 503;
          } else if (
            error.code === LocalNetworkRequestManager.ERR_CODE_ECONNREFUSED
          ) {
            console.log("ERR_CODE_ECONNREFUSED");
            status = 401;
          } else {
            console.log(error.code);
            status = 500;
          }
          this.handleError(status);
        }
      });
  }
}

export { Connector };
